import { VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators'
import DynamicModule from '@/decorators/DynamicModule'
import Zone from '@/dto/Zone/Zone'
import deliveryStore from '@/stores/DeliveryStore'
import ZoneService from '@/services/ZoneService'
import { NotifyHelper } from 'vue-kit'

@DynamicModule
class ZoneStore extends VuexModule {
  public zones: Zone[] = []
  public zoneId: number | null = null
  public deliveryStore = deliveryStore

  get deliveryId(): number | null {
    const delivery = this.deliveryStore.delivery
    return delivery ? (delivery.id as number) : null
  }

  get zone(): Zone | null {
    if (!this.zoneId) {
      return null
    }

    return this.zones.find(zone => zone.id === this.zoneId) || null
  }

  @Mutation
  selectZone(zoneId: number | null) {
    this.zoneId = zoneId
  }

  @Mutation
  setZones(zones: Zone[]) {
    this.zones = zones
  }

  @Mutation
  addZone(zone: Zone) {
    this.zones.push(zone)
  }

  @Mutation
  deleteZoneFromList(zoneId: number) {
    const index = this.zones.findIndex(zone => zone.id === zoneId)
    this.zones.splice(index, 1)
  }

  @Action({ rawError: true })
  async createZone(zoneName: string) {
    return ZoneService.createZone(this.deliveryId as number, zoneName)
      .then((zone: Zone) => {
        this.addZone(zone)
      })
      .catch(error => {
        NotifyHelper.error(error.response.data.errors)
      })
  }

  @Action({ rawError: true })
  async updateZone(zone: Zone) {
    return ZoneService.updateZone(zone).catch(error => {
      NotifyHelper.error(error.response.data.errors)
    })
  }

  @Action({ rawError: true })
  async deleteZone(zone: Zone) {
    return ZoneService.deleteZone(zone.id)
      .then(() => this.deleteZoneFromList(zone.id))
      .catch(error => error.response.data.errors)
  }

  @Action({ rawError: true })
  async loadZones() {
    return ZoneService.getZonesByDeliveryId(this.deliveryId as number)
      .then((zones: Zone[]) => {
        this.setZones(zones)
      })
      .catch(error => {
        NotifyHelper.error(error.response.data.errors)
      })
  }
}

export default getModule(ZoneStore)
